import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  communityWrapper: {
    display: 'flex',
    height: 'auto',
    width: '100%',
    gap: theme.spacing(1),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
    borderRadius: theme.shape.borderRadius,
    color: 'unset',
    textDecoration: 'unset',
    border: '1px solid transparent',
    boxSizing: 'border-box',

    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      cursor: 'pointer',
    },
  },

  infoWrapper: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },

  infoName: {
    fontWeight: 600,
  },

  communityWrapperWithMargin: {
    marginTop: theme.spacing(1), // using theme.spacing for consistent margin
  },
}));
